import {
  SLR_CONTRACT_START,
  SLR_CONTRACT_END,
  SLR_CONTRACT_BY_ID,
  SLR_CONTRACT_RESET,
  SLR_POSTED_LOADING_START,
  SLR_POSTED_LOADING_END,
  SLR_POSTED_RESULTS_SUCCESS,
} from '../../actions/SalesRebate/ActionTypes';

const initialState = {
  loading: false,
  contractDataById: {},
  postedLoading: false,
  postedResults: null,
};

const SalesRebateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SLR_CONTRACT_BY_ID:
      return { ...state, contractDataById: action.data };
    case SLR_CONTRACT_START:
      return { ...state, loading: true };
    case SLR_CONTRACT_END:
      return { ...state, loading: false };
    case SLR_CONTRACT_RESET:
      return initialState;
    case SLR_POSTED_LOADING_START:
      return { ...state, postedLoading: true };
    case SLR_POSTED_LOADING_END:
      return { ...state, postedLoading: false };
    case SLR_POSTED_RESULTS_SUCCESS:
      return { ...state, postedResults: action.data };
    default:
      return state;
  }
};

export default SalesRebateReducer;
